import * as React from "react";
import { SVGProps } from "react";
const SvgDashboard02 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V5ZM6 19v6h20v-6H6Zm-1-2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H5ZM5 4a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2H5ZM4 9a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm1 3a1 1 0 0 0 0 2h9a1 1 0 0 0 0-2H5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDashboard02;
